import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const Nav = () => {
  const [activeMenu, setActiveMenu] = useState("home");
  const location = useLocation();
  if (location.pathname.includes("mobilerating")) {
    return;
  }
  // const call = () => {
  //   alert("Your token is " + localStorage.getItem("token"));
  // };

  // const logout = () => {
  //   localStorage.clear();
  //   window.location.href = "/";
  // };

  const renderContent = () => {
    if (activeMenu === "home") {
      return (
        <div>
          <h2>Home Page Content</h2>
        </div>
      );
    }
    if (activeMenu === "about") {
      return (
        <div>
          <h2>About Page Content</h2>
        </div>
      );
    }
    if (activeMenu === "contact") {
      return (
        <div>
          <h2>Contact Page Content</h2>
        </div>
      );
    }
    return null;
  };

  if (localStorage.getItem("token") == null) {
    return (
      <>
        <nav className="navbar navbar-expand navbar-light fixed-top">
          <Link className="navbar-brand">
            <img
              src={`${process.env.PUBLIC_URL}/images/cv_ifir_logo.png`}
              alt="Logo"
              style={{ height: "60px", width: "230px" }}
            />
          </Link>
          <div className="container">
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav ml-auto">
                <li
                  className="nav-item"
                  style={{ padding: "0px 35px", marginTop: "10px" }}
                >
                  <Link className="nav-link" to={"/"}>
                    <h5>Home</h5>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  style={{ padding: "0px 35px", marginTop: "10px" }}
                >
                  <Link className="nav-link" to={"/register"}>
                    <h5>About</h5>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  style={{ padding: "0px 35px", marginTop: "10px" }}
                >
                  <Link
                    className="nav-link"
                    to={"https://www.tatamotors.com/contact-us/"}
                    target="_blank"
                  >
                    <h5>Contact</h5>
                  </Link>
                </li>
                <li className="nav-item" style={{ padding: "0px 35px" }}>
                  <Link className="nav-link" to={"/login"}>
                    <button
                      type="button"
                      style={{
                        backgroundColor: "#0d6efd",
                        color: "white",
                        border: "none",
                        padding: "10px 18px 6px 18px",
                        borderRadius: "5px",
                      }}
                    >
                      <h5>Login</h5>
                    </button>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <Link className="navbar-brand">
            <img
              src={`${process.env.PUBLIC_URL}/images/logotmlbsl.png`}
              alt="Logo"
              style={{ height: "30px", width: "250px" }}
            />
          </Link>
        </nav>
        <div className="content">{renderContent()}</div>
      </>
    );
  } else {
    return (
      <nav className="navbar navbar-expand navbar-light fixed-top">
        <div className="container">
          <div className="collapse navbar-collapse">
            <div className="sidenav">
              <a href="#section">Services</a>
            </div>
            <div className="sidenav">
              <a href="#section">Clients</a>
            </div>
            <div className="sidenav">
              <a href="#section">Contact</a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Nav;
